export default __webpack_public_path__ + "img/c4e63f57fe28e20be01dec703a26fc52.png";